import Vue from 'vue';
import moment from 'moment';
Vue.filter('clp', (value) => {
    const amount = new Intl.NumberFormat("es-CL").format(value);
    // eslint-disable-next-line no-useless-escape
    return `\$${amount}`;
});

Vue.filter('date', (value) => {
  try {
    let fecha = value.split("T");
    if (fecha[0].match(/^\d{4}-\d{2}-\d{2}/)) {
        console.log("Fecha con formato YYYY-MM-DD");
        return moment.utc(fecha[0], "YYYY-MM-DD").format("DD/MM/YYYY");
    } else if (fecha[0].match(/^\d{2}-\d{2}-\d{4}/)) {
        console.log("Fecha con formato DD-MM-YYYY");
        return moment.utc(fecha[0], "DD-MM-YYYY").format("DD/MM/YYYY");
    }
  } catch (error) {
      console.error("Error formateando fecha", value, error.message);
      return moment.utc().format("DD/MM/YYYY");
  }
});

Vue.filter('paymentTypeDescription', (value) => {
  if (value == 'Credito') {
    return "Crédito";
  }
  return value;
});

Vue.filter('paymentType', (value) => {
    let paymentType = value
    if (value) {
        if ("VC" == value.toUpperCase()) {
            paymentType = "Venta Crédito"
        }
        if ("VD" == value.toUpperCase()) {
            paymentType = "Venta Débito"
        }
    }
    return paymentType;
});
